export enum SelectedTeam {
    none = "none",
    home = "home",
    away = "away",
}
